import * as types from './types';
import { getVideoSchemaDataFromVideoArticle } from './types/videoObjectType';

const addSchema = type => ({
  '@context': 'https://schema.org',
  '@graph': [type]
});

const getType = content => {
  switch (content.bundle) {
    case 'article':
      if (content.mediaType === 'shortform') {
        return types.videoObjectType(
          getVideoSchemaDataFromVideoArticle(content)
        );
      }
      if (content.isEverGreen) {
        return types.articleType(content);
      }
      return types.newsArticleType(content);
    case 'homepage':
      return types.webSiteType();
    case 'author':
    case 'photographer':
      return types.articleType(content);
    case 'error_404':
    case 'error_403':
    case 'hub_page':
    case 'page':
    case 'search':
    case 'subscribe_page':
    case 'taxonomy':
    case 'television_schedule':
    case 'consent_management':
    case 'newsletter':
      return types.webPageType(content);
    case 'photo_gallery':
    case 'vertical_slideshow_gallery':
    case 'pod_index':
      return types.imageGalleryType(content);
    case 'show':
      return types.tvSeriesType(content);
    default:
      throw new Error(`Unknown content bundle "${content.bundle}".`);
  }
};

export const schemaService = {
  getSchema: content => addSchema(getType(content)),

  getStandaloneImageSchema: imageEntity => {
    const type = types.imageObjectType(imageEntity);
    return type
      ? {
          '@context': 'https://schema.org',
          ...type
        }
      : null;
  },
  getStandaloneVideoSchema: schemaData => {
    const type = types.videoObjectType(schemaData);
    return type
      ? {
          '@context': 'https://schema.org',
          ...type
        }
      : null;
  }
};
